import { useRequestStore } from '@/stores/requests'

export default defineNuxtPlugin(async (nuxtApp) => {
    const requestStore = useRequestStore()

    const locale = nuxtApp.$i18n.locale.value

    await requestStore.fillPageIndex(locale)
    await requestStore.fillGlobals(locale)
});
